import { Drawer, Layout, Menu } from "antd";
import styled, { css } from "styled-components";

export const ContentButton = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--velotax-background-color-ghost);
`;

export const DrawerSider = styled(Drawer)`
  z-index: 99999999999;
  .ant-drawer-wrapper-body {
    position: relative;
    .ant-drawer-header {
      right: 16px;
      top: 24px;
      padding: 0;
      position: absolute;
      background-color: var(--velotax-background-color);
    }
    .ant-drawer-body {
      padding: 0;
      background-color: var(--velotax-background-color);
    }
  }
`;

export const LayoutSider = styled(Layout.Sider)`
  position: relative;
  z-index: 11;
`;

export const Modules = styled(Menu)`
  overflow-y: auto;
  overflow-x: hidden;
  border-right: none;
  height: calc(100% - 65px);
  border-top: 1px solid var(--velotax-background-color-ghost);
  &.user {
    height: calc(100% - 64px - 128px);
  }
  &.poweredBy {
    height: calc(100% - 65px - 64px);
  }
  &.user.poweredBy {
    height: calc(100% - 65px - 64px);
  }
`;

export const Settings = styled(Menu)`
  width: 100%;
  height: 80px;
  display: flex;
  border-right: none;
  border-top: 1px solid var(--velotax-background-color-ghost);

  .ant-row {
    width: 100%;
  }
`;

interface ModuleProps {
  sidebarselectedcolor: string;
}

export const ModuleSubMenu = styled(Menu.SubMenu)<ModuleProps>`
  position: relative;
  margin: 0 !important;
  min-height: 64px !important;
  transition: color 500ms ease-in-out;
  color: var(--velotax-font-color-ghost) !important;
  background-color: var(--velotax-background-color);
  border-top: 1px solid var(--velotax-background-color-ghost);

  &:first-of-type {
    border-top: none;
  }

  * {
    z-index: 1;
  }

  svg {
    margin-right: 4px;
  }

  &::before {
    content: "";
    top: 8px;
    left: 8px;
    z-index: 0;
    opacity: 0;
    height: 48px;
    position: absolute;
    border-radius: 4px;
    width: calc(100% - 16px);
    background-color: var(--velotax-ghost);
    transition: opacity 500ms ease-in-out;
  }

  &.ant-menu-submenu {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .ant-menu-submenu-title {
      height: 64px;
      margin-top: 0;
      margin-bottom: 0;
      font-weight: 500;
      padding-left: 16px !important;
      &:active {
        background-color: var(--velotax-background-color);
      }
      .ant-menu-submenu-arrow {
        color: var(--velotax-font-color-ghost);
      }
    }
  }

  &.ant-menu-submenu-selected {
    &::before {
      opacity: 1;
    }
    .ant-menu-submenu-title {
      font-weight: 600;
    }
  }

  .ant-menu-sub {
    padding-left: 16px;
    background-color: var(--velotax-background-color);
    .ant-menu-item {
      padding-left: 16px !important;
      &:first-of-type {
        border-top: 1px solid var(--velotax-background-color-ghost);
      }
    }
  }

  ${(props) =>
    props.sidebarselectedcolor
      ? css`
          &:hover {
            .ant-menu-submenu-arrow,
            .ant-menu-submenu-title {
              color: ${props.sidebarselectedcolor} !important;
            }
          }
          &.ant-menu-submenu-open {
            color: ${props.sidebarselectedcolor} !important;
            .ant-menu-submenu-title .ant-menu-submenu-arrow {
              color: ${props.sidebarselectedcolor};
            }
          }
          &.ant-menu-submenu-selected {
            color: ${props.sidebarselectedcolor} !important;
            .ant-menu-submenu-title {
              font-weight: 600;
              .ant-menu-submenu-arrow {
                color: ${props.sidebarselectedcolor};
              }
            }
          }
        `
      : css`
          &:hover {
            .ant-menu-submenu-arrow,
            .ant-menu-submenu-title {
              color: var(--ant-primary-color) !important;
            }
          }
          &.ant-menu-submenu-open {
            color: var(--ant-primary-color) !important;
            .ant-menu-submenu-title .ant-menu-submenu-arrow {
              color: var(--ant-primary-color);
            }
          }
          &.ant-menu-submenu-selected {
            color: var(--ant-primary-color) !important;
            .ant-menu-submenu-title .ant-menu-submenu-arrow {
              color: var(--ant-primary-color);
            }
          }
        `}
`;

export const Module = styled(Menu.Item)<ModuleProps>`
  color: var(--velotax-font-color-ghost) !important;
  margin: 0 !important;
  height: 64px !important;
  border-top: 1px solid var(--velotax-background-color-ghost);
  background-color: var(--velotax-background-color);
  transition: color 500ms ease-in-out;
  padding-left: 16px !important;
  font-weight: 500;

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: 1px solid var(--velotax-background-color-ghost);
  }

  * {
    z-index: 1;
  }

  svg {
    margin-right: 4px;
  }

  &.ant-menu-item:active {
    background-color: var(--velotax-background-color);
  }

  &.ant-menu-item-selected {
    font-weight: 600;
    background-color: var(--velotax-background-color) !important;

    &::after {
      border-right: none;
      opacity: 0;
    }

    &::before {
      opacity: 1;
    }
  }

  &::before {
    content: "";
    top: 8px;
    left: 8px;
    z-index: 0;
    opacity: 0;
    position: absolute;
    border-radius: 4px;
    width: calc(100% - 16px);
    height: calc(100% - 16px);
    background-color: var(--velotax-ghost);
    transition: opacity 500ms ease-in-out;
  }

  &.setting {
    width: 100%;
    color: var(--velotax-font-color-ghost);
    border-top: none;
    border-bottom: none;
    height: 80px !important;
    padding: 12px 8px 4px 8px !important;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-right: 1px solid var(--velotax-ghost);

    svg {
      margin-right: 0;
    }

    .ant-menu-title-content {
      margin: 0;
    }

    &.logout {
      border: none;
    }

    &.logout::before {
      opacity: 0;
    }
  }

  ${(props) =>
    props.sidebarselectedcolor
      ? css`
          &:hover {
            color: ${props.sidebarselectedcolor} !important;
          }
          &.ant-menu-item-selected {
            color: ${props.sidebarselectedcolor} !important;
            &:hover {
              color: ${props.sidebarselectedcolor};
            }
          }
        `
      : css`
          &:hover {
            color: var(--ant-primary-color) !important;
            svg {
              color: var(--ant-primary-color) !important;
            }
            svg:not(.no-fill) {
              fill: var(--ant-primary-color) !important;
            }
          }
          &.ant-menu-item-selected {
            color: var(--ant-primary-color) !important;
            svg {
              color: var(--ant-primary-color);
            }
            svg:not(.no-fill) {
              fill: var(--ant-primary-color);
            }
            &:hover {
              color: var(--ant-primary-color);
            }
          }
        `}
`;

export const Review = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--velotax-background-color-ghost);
  background-color: var(--velotax-background-color);
`;

export const Users = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 50px;

  @media only screen and (max-device-width: 812px) {
    .users-button {
      background-color: white;
      box-shadow: none;
      border: none;
    }

    .users-icon {
      height: 15px;
      width: 15px;
    }
  }
`;

export const SupportContainerIcon = styled.div`
  & svg {
    /* height: 17px;
    width: 17px; */
    margin-left: 2px;
    color: var(--ant-primary-color);
  }
`